import { useEffect } from "react";

import InformationArea from "components/InformationArea";
import splash from "assets/images/mittkontor_2.jpg";
import { Loader } from "components/loader/Loader";
import Modal from "components/modal/Modal";
import config from "config/config";
import LoginForm from "./LoginForm";
import SysMessage from "./SysMessage";
import { useRootStore } from "store";

import "./Login.scss";

export default function Login() {
  const { global, user } = useRootStore((state) => state);
  const { fetchSysMessage, isNewPass } = useRootStore(
    (state) => state.notifications
  );
  const { isNewPass: userNewPass, sysMessage } = useRootStore(
    (state) => state.user
  );
  const { isAuthenticating } = user;
  const { supportContactInformation, informationArea } =
    global.staticInformation;

  useEffect(() => {
    fetchSysMessage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  let header = "Välkommen till MittKontor!";
  if (config.stage !== "production") {
    header += ` (${config.stage?.toUpperCase()})`;
  }
  return (
    <>
      {isAuthenticating ? (
        <div
          style={{
            minHeight: "50vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
          }}
        >
          <Loader className="mr-3" /> <p>Loggar in...</p>
        </div>
      ) : (
        <div className="login">
          <div className="loginGrid">
            <div className="loginFormBox box">
              <h1>{header}</h1>
              <hr className="header-border" />

              {userNewPass && (
                <Modal
                  onDismiss={() => {
                    isNewPass(false);
                  }}
                  modalTitle="update password"
                >
                  <div>
                    Nu är ditt lösenord uppdaterat. Vänligen logga in igen.{" "}
                  </div>
                </Modal>
              )}

              <SysMessage messageInfo={sysMessage} />

              <LoginForm />
            </div>

            <div className="loginImage boxImage">
              <img alt="Ludvig &amp; Co" src={splash} />
            </div>

            <div className={"box"}>
              <h2>Behöver du hjälp?</h2>
              <p className="linkText">
                <a
                  target="_blank"
                  rel="noreferrer"
                  href={supportContactInformation.externalSupportSite}
                >
                  Frågor och svar
                </a>
              </p>
              <InformationArea
                info={informationArea}
                key={"information-area"}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}
